window.Branch.functions.defineInitFunctionSafely('initHomePageTrustBadge', function () {
  let trustBadgeEesizeTimeout;
  let trustBadgeWindowWidth;
  let homePageTrustBadgeSections = document.querySelectorAll('.custom-trust_badge_section');

  homePageTrustBadgeSections.forEach((homePageTrustBadgeSection) => {
    homePageTrustBadgeSection.parentElement.setAttribute('data-repositioned-type', 'desktop');
  })

  const repositionTrustBadgeSections = function(type){
    homePageTrustBadgeSections.forEach((homePageTrustBadgeSection) => {
      let homePageTrustBadgeParent = homePageTrustBadgeSection.parentElement;
      let repositionIndex = parseInt(homePageTrustBadgeSection.getAttribute('data-mobile-reposition-index'));
      if(repositionIndex != 0){
        let allowReposition = false;

        if(type == 'init' || homePageTrustBadgeParent.getAttribute('data-repositioned-type') == 'mobile' && window.innerWidth > 599 || homePageTrustBadgeParent.getAttribute('data-repositioned-type') == 'desktop' && window.innerWidth < 600){
          allowReposition = true;
        };

        if(allowReposition == true){
          let newPosition = type == 'init' || homePageTrustBadgeParent.getAttribute('data-repositioned-type') == 'desktop' ? repositionIndex : 0 - repositionIndex - 1;
          if(newPosition > 0){
            homePageTrustBadgeParent.setAttribute('data-repositioned-type', 'mobile')
          } else {
            homePageTrustBadgeParent.setAttribute('data-repositioned-type', 'desktop')
          }
          if(newPosition != 0){
            let parentContainer = homePageTrustBadgeParent.parentElement;
            let allSections = Array.from(parentContainer.children);
            let currentIndex = allSections.indexOf(homePageTrustBadgeParent);
            let newPositionIndex = Math.max(0, currentIndex - newPosition);
            let sectionBefore = allSections[newPositionIndex];
      
            parentContainer.insertBefore(homePageTrustBadgeParent, sectionBefore);
          }
        }
      }
    });
  }

  if(window.innerWidth < 600){
    repositionTrustBadgeSections('init')
  }

  window.addEventListener('resize', () => {
    clearTimeout(trustBadgeEesizeTimeout);

    trustBadgeEesizeTimeout = setTimeout(() => {
      if(trustBadgeWindowWidth != window.innerWidth){
        trustBadgeWindowWidth = window.innerWidth;
          repositionTrustBadgeSections('resize')
      }
    }, 200);
  });
})

window.onload = initHomePageTrustBadge();
